import api from "@/router/api"

export default {
	listAllUsers({commit}, payload){
		return new Promise((resolve, reject) => {
			api.users.listAll(payload)
				.then(response => {
					const {data} = response
					commit('SET_USERS', data.data)
					resolve(data)
				})
				.catch(() => {
					reject({
						message: 'Error al obtener los usuarios'
					})
				})
		})
	},
	getUser({commit}, payload){
		return new Promise((resolve, reject) => {
			api.users.find(payload.id, payload)
				.then(response => {
					resolve(response.data.data)
				})
				.catch(error => {
					reject({
						message: 'Ocurrió un problema al obtener el usuario',
					})
				})
		})
	},
	createUser({commit}, payload){
		commit('CLEAR_VALIDATION')
		return new Promise((resolve, reject) => {
			api.users.create(payload)
				.then(response => {
					const {data} = response.data

					resolve(data)
				})
				.catch(error => {
					const { data, status} = error.response
					const { message: title } = data

					if(status === 422){
						commit('SET_VALIDATION_ERRORS', data.errors)
					}
					reject({title, status})
				})
		})
	},
	updateUser({commit}, payload){
		commit('CLEAR_VALIDATION')
		return new Promise((resolve, reject) => {
			api.users.update(payload)
				.then(response => {
					const {data} = response.data

					resolve(data)
				})
				.catch(error => {
					const { data, status} = error.response
					const { message: title } = data

					if(status === 422){
						commit('SET_VALIDATION_ERRORS', data.errors)
					}
					reject({title, status})
				})
		})
	},
	deleteUser({commit}, payload) {
		return new Promise((resolve, reject) => {
			api.users.delete(payload)
				.then(response => {
					const {data} = response.data

					resolve(data)
				})
				.catch(() => {
					reject({
						message: 'Error al eliminar el usuario.',
					})
				})
		})
	},
	getAllUsers({commit}, payload) {
		return new Promise((resolve, reject) => {
			api.users.listAll(payload)
				.then(response => {
					const {data} = response.data

					resolve(data)
				})
				.catch(() => {
					reject({
						message: 'Error al obtener los usuarios.',
					})
				})
		})
	},
	getUsersDiary({commit}, payload) {
		return new Promise((resolve, reject) => {
			api.users.listDiary(payload)
				.then(response => {
					const {data} = response.data

					resolve(data)
				})
				.catch(() => {
					reject({
						message: 'Error al obtener los usuarios.',
					})
				})
		})
	},
    getUsersByCenter({commit}, payload) {
        return new Promise((resolve, reject) => {
            api.users.listByCenter(payload.id, payload)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(() => {
                    reject({
                        message: 'Error al obtener los usuarios.',
                    })
                })
        })
    },
	getEducatorsByCenter({commit}, payload) {
		return new Promise((resolve, reject) => {
			api.users.educatorsByCenter(payload.id, payload)
				.then(response => {
					const {data} = response.data

					resolve(data)
				})
				.catch(() => {
					reject({
						message: 'Error al obtener los usuarios.',
					})
				})
		})
	},
	markNotificationsAsRead({commit}, payload) {
		return new Promise((resolve, reject) => {
			api.users.markNotificationsAsRead(payload)
				.then(response => {
					const {data} = response.data
					commit('SET_NOTIFICATIONS', data)
					resolve(data)
				})
				.catch(() => {
					reject({
						message: 'Error al obtener las notificaciones'
					})
				})
		})
	},
	markNotificationAsRead({commit}, payload) {
		return new Promise((resolve, reject) => {
			api.users.markNotificationAsRead(payload)
				.then(response => {
					const {data} = response.data
					commit('SET_NOTIFICATIONS', data)
					resolve(data)
				})
				.catch(() => {
					reject({
						message: 'Error al obtener las notificaciones'
					})
				})
		})
	}
}
